var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmiley = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 19.643a9.643 9.643 0 1 0 0-19.286 9.643 9.643 0 0 0 0 19.286zm-3.857-10.607a1.929 1.929 0 1 0 0-3.857 1.929 1.929 0 0 0 0 3.857zm9.643-1.929a1.929 1.929 0 1 1 -3.857 0 1.929 1.929 0 0 1 3.857 0zm.776 6.09c-.774 2.585-3.802 4.517-6.562 4.517s-5.788-1.932-6.562-4.518c-.204-.68.388-1.267 1.098-1.267h10.928c.71 0 1.302.587 1.098 1.267z",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmiley);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smiley.f5e22a3355195ae52799639b82c58f1a.svg";